/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { helpers } from '@glowingblue-orell-thalia-common';
import { slug } from '../../../../common';
import AbstractInput from './AbstractInput';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.banner_form.inputs.labels`;

export default class DateSelect extends AbstractInput {
	oninit(vnode) {
		super.oninit(vnode);

		if (typeof this.value() === 'string') {
			this.value(new Date(this.value()));
		}
	}

	get defaultValue() {
		return undefined;
	}

	className() {
		return `${super.className()} ${super.className()}--date`;
	}

	content() {
		const { name } = this.attrs;

		return [
			<label className="label">{t(`${prfx}.${name}`)}</label>,
			<div className="BannerForm--date" oncreate={(vnode) => this.initDatePicker(vnode)} onupdate={() => this.syncDatePicker()}>
				<input className="FormControl" data-input style={{ opacity: 1, color: 'inherit' }} />
			</div>,
		];
	}

	initDatePicker(vnode) {
		const userLang = app.translator.getLocale ? app.translator.getLocale() : app.translator.formatter.locale;

		helpers.loadDynLib('flatpickr', [userLang]).then(() => {
			const locale = flatpickr.l10ns[userLang];

			this.flatpickrInstance = flatpickr(vnode.dom, {
				enableTime: true,
				dateFormat: 'Y-m-d H:i',
				time_24hr: true,
				defaultDate: this.value(),
				locale,
				wrap: true,

				onChange: (dates) => {
					this.value(dates[0]);
					m.redraw();
				},
			});

			this.lastSyncedDate = this.value();
		});
	}

	syncDatePicker() {
		if (!this.flatpickrInstance) return;

		const currentValue = this.value();

		if (currentValue !== this.lastSyncedDate) {
			this.flatpickrInstance.setDate(currentValue, false);
			this.lastSyncedDate = currentValue;
		}
	}
}
